// extracted by mini-css-extract-plugin
export default {"videoPlayerSection":"VideoPlayer_videoPlayerSection__bct2v","overlay":"VideoPlayer_overlay__7Hqru"};